import { getCurrentEnvironment, getDevelopmentConfig } from './environment';

export const getUri: () => string = () => {
  const environment = getCurrentEnvironment();
  const developmentConfig = getDevelopmentConfig();

  // TODO update URI for production and staging to use the correct endpoint
  if (environment.isDev || environment.isStaging || environment.isProd) {
    return 'https://flik-backend-dev.fly.dev';
  }
  if (developmentConfig.overridenApiUrl) {
    return `${developmentConfig.overridenApiUrl}`;
  }
  return 'http://localhost:8000';
};

export const getGraphqlUriComponent = () => {
  return `/graphql`;
};

export const getGraphqlUri = (uri?: string) => {
  if (!uri) {
    uri = getUri();
  }
  return `${uri}${getGraphqlUriComponent()}`;
};

export const getWebSocketUri: () => string = () => {
  const environment = getCurrentEnvironment();
  const developmentConfig = getDevelopmentConfig();

  // TODO update URI for production and staging to use the correct endpoint
  if (environment.isDev || environment.isStaging || environment.isProd) {
    return 'wss://flik-backend-dev.fly.dev/ws/connect';
  }
  if (developmentConfig.overridenApiUrl) {
    // Convert HTTP to WS for overridden URLs
    const wsUrl = developmentConfig.overridenApiUrl.replace(
      /^https?:\/\//,
      'ws://',
    );
    return `${wsUrl}/ws/connect`;
  }
  return 'ws://localhost:8000/ws/connect';
};
